import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { MartinusTemporaryActions } from '../../MartinusTemporaryPolicy.js';
import { abacOperationMiddleware } from '../../permissions/middlewares/abacOperationMiddleware.js';
import { MartinusAccountingEntry } from '../../quittungen/entities/MartinusAccountingEntry.js';
import { DebitorAccountLabel } from '../entities/DebitorAccountLabel.js';
import { resolveGetDebitorAccountLabel } from '../server/resolvers/resolveGetDebitorAccountLabel.js';
import { resolveSubscribeAccountingEntriesForReferenceIDs } from '../server/resolvers/resolveSubscribeAccountingEntriesForReferenceIDs.js';

const subscribeAccountingEntriesForReferenceIDs = registerQuery({
  operationName: 'subscribeAccountingEntriesForReferenceIDs',
  // the books of a person or a whole school — the same guard as the engine's accounting reads
  middlewares: [abacOperationMiddleware(MartinusTemporaryActions.VIEW_ACCOUNTING)],
  type: () => [MartinusAccountingEntry],
  params: [
    { type: () => [ID], name: 'referenceIDs' },
    { type: () => String, name: 'fiscalYear' },
  ],
  resolve: resolveSubscribeAccountingEntriesForReferenceIDs,
});

const getDebitorAccountLabel = registerQuery({
  operationName: 'getDebitorAccountLabel',
  type: () => DebitorAccountLabel,
  params: [
    { type: () => String, name: 'account' },
    { type: () => String, name: 'mandant' },
  ],
  resolve: resolveGetDebitorAccountLabel,
});

export const AccountingAPI = {
  /** every entry of the referenced entities in one fiscal year */
  subscribeForReferences: subscribeAccountingEntriesForReferenceIDs,
  /** the person or virtual debitor behind a debitor account number */
  getDebitorLabel: getDebitorAccountLabel,
};
